import {getUrlParams, specialCharacterSubstring, initWXShare, isOfflinePlat} from '../../utils';
import {openShare, initShare, loadScript, jsonp, appendParam} from '@baidu/map-fe-utils';

import {getLocation, getBosResizeUrl} from './utils.js';

// 初始化我微信SKD && 获取微信签名
function initWxFn({wxShareUid, dataList, pushSource}) {
    return new Promise(resolve => {
        Promise.all([getShareData({wxShareUid}), loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js', {globals: 'wx'})]).then(res => {
            const shareData = res[0] || {};
            const shareOptions = initWxShareOptions(dataList, pushSource);
            const wxShareConfig = setWxShareConfig(shareData);
            initWXShare(wxShareConfig, shareOptions);
            resolve(shareData);
        });
    });
}

// 获取微信签名&poi信息
function getShareData(shareObj = {wxShareUid: ''}) {
    // todo del mayao
    // let url = 'http://lbs-ebm-ibip-explore0002.bcc-szwg.baidu.com:8983/cube/feed/getpagedata';
    let url = 'https://ugc.map.baidu.com/cube/feed/getpagedata';
    let param = {};
    const params = getUrlParams(location.href);
    const {isShare = 0} = params || {};
    if (isShare) {
        param.isShare = isShare;
        param.share_poi_uid = shareObj.wxShareUid;
        // url不需要encode,jsonp内部会encode
        param.share_url = location.href;
    }
    return new Promise((resolve, reject) => {
        jsonp(
            url,
            param,
        ).then(res => {
            if (res && typeof res.page_data === 'string') {
                const parsedData = JSON.parse(res.page_data);
                if (parsedData) {
                    resolve(parsedData);
                }
                else {
                    reject(null);
                }
            }
            else {
                reject(null);
            }

        }).catch(e => {
            console.warn(e, 'error');
        });
    });
};

// 点击分享按钮设置分享数据
async function setShareOption(shareObj, pushSource) {
    let {
        wxTitle: title = '',
        wxDesc: desc = '',
        pic = '',
        unique_id = '',
        index = '',
        poiUid = '',
        poiX = '',
        poiY = ''
    } = shareObj || {};

    title = specialCharacterSubstring(title, 0, 32);

    desc = handleShareDesc(desc, pushSource);
    // 分享内容限制50字以内
    pic = handleShareIcon(pic);

    const {origin, pathname} = location;
    // 分享端外定制页面处理
    // const pathname = '/cube/h5/microDetail';
    const params = getUrlParams(location.href);
    const {uid = '', city_id = '', topic = '', tplType = 'article', reqType = ''} = params || {};
    let paramObj = {
        unique_id,
        uid,
        city_id,
        topic,
        tplType,
        isShare: 1,
        source: 'sharefeed'
    };

    if (reqType === 'poicomment') {
        paramObj.reqType = reqType;
        paramObj.index = index;
    }

    const wxParamObj = {
        ...paramObj,
        share_poi_uid: poiUid,
        poi_x: poiX,
        poi_y: poiY
    };

    const contentType = 'text'; // 必传，链接优先时，固定值为text
    const from = 'NewFeedShare'; // 用于分享面板内部的统计，必传且唯一

    let url = origin + pathname;

    // 组件包的分享地址
    if (isOfflinePlat) {
        url = 'https://newclient.map.baidu.com/feed-h5/micro-detail';
    }
    let wxUrl = appendParam(url, wxParamObj);
    let copyLinkUrl = appendParam(url, paramObj);
    // 定义分享数据
    const data = [
        {
            src: 'weixin',
            title,
            text: desc,
            url: wxUrl,
            contentType,
            pic: pic, // 微信分享图片尺寸有要求，需单独设置
            from
        },
        {
            src: 'friend',
            text: title,
            url: wxUrl,
            contentType,
            pic: pic, // 微信分享图片尺寸有要求，需单独设置
            from
        },
        {
            src: 'weibo',
            text: title,
            url: copyLinkUrl,
            pic: pic,
            from
        },
        {
            src: 'copy_link',
            url: copyLinkUrl, // 必传参数
            from
        }
    ];
    initShare(data);
    openShare();
};

// 处理分享图标
function handleShareIcon(src) {
    let pic = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/mapicons.png';
    // 没有分享图片，则使用默认图标
    if (!src) {
        return pic;
    }
    const {hostname = ''} = getLocation(src);
    const isBcebosSrc = hostname.endsWith('.cdn.bcebos.com');
    if (isBcebosSrc) {
        pic = getBosResizeUrl({src, focus: true});
    }

    return pic;
};

// 处理分享描述文案
function handleShareDesc(desc = '', pushSource) {
    // 移除文章中<br/>标签以及\n
    desc = desc.replace(/<br\s*\/?>/g, '');
    desc = desc.replace(/\n/g, '');

    // 分享内容限制50字以内
    desc = specialCharacterSubstring(desc, 0, 50);

    if (desc.includes('<') || pushSource) {
        desc = '';
    }

    return desc;

};

function setWxShareConfig(config) {
    const {appId, timestamp, nonceStr, signature} = config;
    const wxShareConfig = {
        appId,
        timestamp,
        nonceStr,
        signature,
        openTagList: ['wx-open-launch-app'],
        jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData']
    };
    return wxShareConfig;
}
// 微信内分享到朋友圈配置文案
function initWxShareOptions(dataList = [], pushSource) {

    const {body} = dataList[0] || {
        body: {
            cover: {src: ''},
            article: {headline: '', content: ''}
        }
    };
    let {article: {headline = '', content = ''}} = body;
    const {src} = body.cover || {src: ''};

    const title = specialCharacterSubstring(headline, 0, 32);
    const desc = handleShareDesc(content, pushSource);
    const imgUrl = handleShareIcon(src);
    const shareObj = {
        title,
        imgUrl,
        desc
    };

    return shareObj;
};

export {
    getShareData,
    setShareOption,
    handleShareIcon,
    handleShareDesc,
    initWxShareOptions,
    initWxFn
};